import {
  ApiBlueprint,
  FrontendPlugin,
  PageBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { ScorecardApiClient, scorecardApiRef } from './api';
import { rootRouteRef } from './routes';

const scorecardApi = ApiBlueprint.make({
  name: 'scorecard',
  params: define =>
    define({
      api: scorecardApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new ScorecardApiClient({ discoveryApi, fetchApi }),
    }),
});

const scorecardPage = PageBlueprint.make({
  name: 'scorecard',
  params: {
    path: '/scorecard/:namespace/:kind/:name',
    routeRef: rootRouteRef,
    loader: () =>
      import('./components/ScorecardPage').then(m => <m.ScorecardPage />),
  },
});

const scorecardEntityContent = EntityContentBlueprint.make({
  name: 'scorecard',
  params: {
    path: '/scorecard',
    title: 'Scorecard (Alpha)',
    filter: {
      $any: [{ kind: 'component', 'spec.type': 'service' }, { kind: 'group' }],
    },
    loader: () => import('./components/Router').then(m => <m.Router />),
  },
});

const scorecardPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'scorecard',
  routes: { root: rootRouteRef },
  extensions: [scorecardApi, scorecardPage, scorecardEntityContent],
});
export default scorecardPlugin;
